(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-feature-cards-slider')) {
    customElements.define(
      'sh-feature-cards-slider',
      class ShFeatureCardsSlider extends HTMLElement {
        connectedCallback() {
          this.desktopItems = Number(this.dataset.desktopItems || 3);
          this.tabletItems = Number(this.dataset.tabletItems || 2);
          this.mobileItems = Number(this.dataset.mobileItems || 1.15);
          this.spaceBetween = Number(this.dataset.spaceBetween || 20);
          this.sliderInstance = null;
          this.initWhenReady();
        }

        disconnectedCallback() {
          this.destroySlider();
        }

        isThemeReady() {
          return Boolean(
            window.FoxTheme &&
              FoxTheme.Carousel &&
              FoxTheme.Swiper &&
              FoxTheme.Swiper.Swiper
          );
        }

        initWhenReady() {
          if (this.isThemeReady()) {
            this.initSlider();
            this.bindEditorEvents();
            return;
          }

          this.readyTimer = setInterval(() => {
            if (!this.isConnected) {
              clearInterval(this.readyTimer);
              this.readyTimer = null;
              return;
            }

            if (this.isThemeReady()) {
              clearInterval(this.readyTimer);
              this.readyTimer = null;
              this.initSlider();
              this.bindEditorEvents();
            }
          }, 50);
        }

        bindEditorEvents() {
          if (!window.Shopify || !Shopify.designMode || this._editorBound) return;
          this._editorBound = true;

          this.addEventListener('shopify:block:select', (event) => {
            const slide = event.target.closest('.swiper-slide');
            if (!slide || !this.sliderInstance || !this.sliderInstance.slider) return;
            const index = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(slide);
            if (index >= 0) this.sliderInstance.slider.slideTo(index);
          });
        }

        initSlider() {
          if (!this.isThemeReady() || this.sliderInstance) return;

          this.sliderInstance = new window.FoxTheme.Carousel(
            this,
            {
              slidesPerView: this.mobileItems,
              spaceBetween: this.spaceBetween,
              watchOverflow: true,
              loop: false,
              threshold: 2,
              grabCursor: true,
              allowTouchMove: true,
              simulateTouch: true,
              touchStartPreventDefault: false,
              mousewheel: {
                enabled: true,
                forceToAxis: true,
              },
              breakpoints: {
                768: {
                  slidesPerView: this.tabletItems,
                  spaceBetween: this.spaceBetween,
                },
                1024: {
                  slidesPerView: this.desktopItems,
                  spaceBetween: this.spaceBetween,
                },
              },
            },
            [FoxTheme.Swiper.Mousewheel]
          );
          this.sliderInstance.init();
        }

        destroySlider() {
          if (this.readyTimer) {
            clearInterval(this.readyTimer);
            this.readyTimer = null;
          }

          if (!this.sliderInstance || !this.sliderInstance.slider) {
            this.sliderInstance = null;
            return;
          }

          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sh-product-reviews')) {
    customElements.define(
      'sh-product-reviews',
      class ShProductReviews extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;

          this.sectionId = this.dataset.sectionId;
          this.shopifySection = document.getElementById(`shopify-section-${this.sectionId}`);
          this.store = this.dataset.store || '';
          this.compactCount = Number(this.dataset.compactCount || 4);
          this.expandedCount = Number(this.dataset.expandedCount || 8);
          this.writeUrl = this.dataset.writeUrl || '';
          this.lang = this.dataset.lang || 'de';
          this.sku = this.buildSku();
          this.sort = 'date_desc';
          this.ratingFilter = '';
          this.mode = 'compact';
          this.page = 1;
          this.reviewCount = 0;
          this.resultsCount = 0;
          this.ratingCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
          this.reviews = [];
          this.abortController = null;

          this.panel = this.querySelector('[data-sh-pr-panel]');
          this.grid = this.querySelector('[data-sh-pr-grid]');
          this.scoreEl = this.querySelector('[data-sh-pr-score]');
          this.summaryStarsEl = this.querySelector('[data-sh-pr-summary-stars]');
          this.countEl = this.querySelector('[data-sh-pr-count]');
          this.barsEl = this.querySelector('[data-sh-pr-bars]');
          this.expandBtn = this.querySelector('[data-sh-pr-expand]');
          this.moreBtn = this.querySelector('[data-sh-pr-more]');
          this.backBtn = this.querySelector('[data-sh-pr-back]');
          this.emptyEl = this.querySelector('[data-sh-pr-empty]');
          this.sortWrap = this.querySelector('[data-sh-pr-sort-wrap]');
          this.sortToggle = this.querySelector('[data-sh-pr-sort-toggle]');
          this.sortPanel = this.querySelector('[data-sh-pr-sort-panel]');
          this.sortClear = this.querySelector('[data-sh-pr-sort-clear]');
          this.ratingList = this.querySelector('[data-sh-pr-rating-list]');
          this.writeBtn = this.querySelector('[data-sh-pr-write]');
          this.modal = this.querySelector('[data-sh-pr-modal]');
          this.modalBody = this.querySelector('[data-sh-pr-modal-body]');
          this.modalOpen = false;
          this.formObserver = null;
          this.formPollTimer = null;
          this._onModalKeydown = this.onModalKeydown.bind(this);
          this._onModalClick = this.onModalClick.bind(this);
          this._onDocumentClick = this.onDocumentClick.bind(this);

          if (window.Shopify && Shopify.designMode && this.shopifySection) {
            this.shopifySection.classList.add('sh-pr-section--editor');
          }

          this.bindEvents();
          this.fetchReviews({ reset: true });
        }

        disconnectedCallback() {
          if (this.abortController) this.abortController.abort();
          this.teardownWriteModal(true);
          document.removeEventListener('click', this._onDocumentClick);
        }

        buildSku() {
          const parts = [];
          const variantSkus = (this.dataset.variantSkus || '')
            .split(';')
            .map((sku) => sku.trim())
            .filter(Boolean);
          const variantIds = (this.dataset.variantIds || '')
            .split(';')
            .map((id) => id.trim())
            .filter(Boolean);

          parts.push(...variantSkus);
          parts.push(...variantIds);
          if (this.dataset.productId) parts.push(this.dataset.productId);
          if (this.dataset.productHandle) parts.push(this.dataset.productHandle);

          return [...new Set(parts)].join(';');
        }

        bindEvents() {
          if (this.sortToggle) {
            this.sortToggle.addEventListener('click', (event) => {
              event.stopPropagation();
              this.toggleSortPanel();
            });
          }

          if (this.sortPanel) {
            this.sortPanel.addEventListener('click', (event) => event.stopPropagation());
          }

          this.querySelectorAll('[data-sh-pr-sort-value]').forEach((button) => {
            button.addEventListener('click', () => {
              this.setSort(button.getAttribute('data-sh-pr-sort-value') || 'date_desc');
            });
          });

          if (this.sortClear) {
            this.sortClear.addEventListener('click', () => this.clearFilters());
          }

          if (this.ratingList) {
            this.ratingList.addEventListener('click', (event) => {
              const button = event.target.closest('[data-sh-pr-rating-value]');
              if (!button) return;
              this.setRatingFilter(button.getAttribute('data-sh-pr-rating-value') || '');
            });
          }

          document.addEventListener('click', this._onDocumentClick);

          if (this.writeBtn) {
            this.writeBtn.addEventListener('click', () => this.openWriteReview());
          }

          this.querySelectorAll('[data-sh-pr-modal-close]').forEach((el) => {
            el.addEventListener('click', () => this.closeWriteModal());
          });

          if (this.expandBtn) {
            this.expandBtn.addEventListener('click', () => {
              this.mode = 'expanded';
              this.fetchReviews({ reset: true });
            });
          }

          if (this.moreBtn) {
            this.moreBtn.addEventListener('click', () => {
              this.fetchReviews({ reset: false, page: this.page + 1 });
            });
          }

          if (this.backBtn) {
            this.backBtn.addEventListener('click', () => {
              this.mode = 'compact';
              this.fetchReviews({ reset: true });
            });
          }
        }

        onDocumentClick() {
          this.closeSortPanel();
        }

        toggleSortPanel() {
          if (!this.sortWrap || !this.sortPanel || !this.sortToggle) return;
          const isOpen = this.sortWrap.classList.contains('is-open');
          if (isOpen) this.closeSortPanel();
          else this.openSortPanel();
        }

        openSortPanel() {
          if (!this.sortWrap || !this.sortPanel || !this.sortToggle) return;
          this.sortWrap.classList.add('is-open');
          this.sortPanel.hidden = false;
          this.sortToggle.setAttribute('aria-expanded', 'true');
        }

        closeSortPanel() {
          if (!this.sortWrap || !this.sortPanel || !this.sortToggle) return;
          this.sortWrap.classList.remove('is-open');
          this.sortPanel.hidden = true;
          this.sortToggle.setAttribute('aria-expanded', 'false');
        }

        hasActiveFilters() {
          return this.sort !== 'date_desc' || Boolean(this.ratingFilter);
        }

        updateFilterUi() {
          this.querySelectorAll('[data-sh-pr-sort-value]').forEach((button) => {
            button.classList.toggle('is-active', button.getAttribute('data-sh-pr-sort-value') === this.sort);
          });

          this.querySelectorAll('[data-sh-pr-rating-value]').forEach((button) => {
            button.classList.toggle(
              'is-active',
              button.getAttribute('data-sh-pr-rating-value') === String(this.ratingFilter)
            );
          });

          if (this.sortClear) this.sortClear.hidden = !this.hasActiveFilters();
        }

        setSort(sortValue) {
          this.sort = sortValue || 'date_desc';
          this.mode = 'compact';
          this.updateFilterUi();
          this.closeSortPanel();
          this.fetchReviews({ reset: true });
        }

        setRatingFilter(ratingValue) {
          const next = String(ratingValue || '');
          this.ratingFilter = this.ratingFilter === next ? '' : next;
          this.mode = 'compact';
          this.updateFilterUi();
          this.closeSortPanel();
          this.fetchReviews({ reset: true });
        }

        clearFilters() {
          this.sort = 'date_desc';
          this.ratingFilter = '';
          this.mode = 'compact';
          this.updateFilterUi();
          this.closeSortPanel();
          this.fetchReviews({ reset: true });
        }

        renderRatingFilters() {
          if (!this.ratingList) return;

          let html = '';
          for (let rating = 5; rating >= 1; rating -= 1) {
            const count = this.ratingCounts[rating] || 0;
            const active = String(this.ratingFilter) === String(rating);
            html += `
              <li>
                <button
                  type="button"
                  class="sh-pr__rating-option${active ? ' is-active' : ''}"
                  data-sh-pr-rating-value="${rating}"
                >
                  <span class="sh-pr__rating-option-main">
                    <span class="sh-pr__rating-stars${count === 0 ? ' is-empty' : ''}" aria-hidden="true">
                      ${this.starsMarkup(rating)}
                    </span>
                    <span class="sh-pr__rating-count">${count}</span>
                  </span>
                  <span class="sh-pr__sort-check" aria-hidden="true">
                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.2L6.5 11.5L13 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                </button>
              </li>
            `;
          }
          this.ratingList.innerHTML = html;
        }

        setLoading(isLoading) {
          if (!this.panel) return;
          this.panel.classList.toggle('is-loading', isLoading);
        }

        revealSection() {
          if (this.shopifySection) this.shopifySection.classList.add('sh-pr-section--ready');
        }

        hideSection() {
          if (window.Shopify && Shopify.designMode) {
            this.revealSection();
            if (this.emptyEl) {
              this.emptyEl.hidden = false;
              this.emptyEl.textContent = 'Für dieses Produkt wurden noch keine Bewertungen abgegeben';
            }
            if (this.grid) this.grid.innerHTML = '';
            this.updateFooter();
            return;
          }

          if (this.shopifySection) {
            this.shopifySection.style.display = 'none';
            this.shopifySection.setAttribute('hidden', '');
          }
        }

        starsMarkup(rating, max = 5) {
          const value = Math.max(0, Math.min(max, Number(rating) || 0));
          let html = '';
          for (let i = 1; i <= max; i += 1) {
            const filled = i <= Math.round(value);
            html += filled
              ? `<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.27l-4.94 2.6.94-5.49-4-3.9 5.53-.8L10 1.5z"/></svg>`
              : `<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.4" d="M10 2.2l2.2 4.45 4.91.71-3.55 3.46.84 4.88L10 13.4l-4.4 2.3.84-4.88L2.89 7.36l4.91-.71L10 2.2z"/></svg>`;
          }
          return html;
        }

        initials(name) {
          const clean = String(name || '')
            .replace(/[^\p{L}\p{N}\s.]/gu, ' ')
            .trim();
          if (!clean) return '?';
          const parts = clean.split(/\s+/).filter(Boolean);
          if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
          return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
        }

        escapeHtml(value) {
          return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        }

        getReviewsWidgetRoot() {
          return (
            document.querySelector('reviewsio-product-reviews-widget') ||
            document.querySelector('[data-reviewsio-widget="polaris"]') ||
            document.querySelector('.reviews-io-polaris-widget')
          );
        }

        revealReviewsWidget(root) {
          if (!root) return null;
          const section = root.closest('.shopify-section') || root;
          section.removeAttribute('hidden');
          section.style.removeProperty('display');
          section.style.removeProperty('visibility');
          section.style.removeProperty('height');
          section.style.removeProperty('overflow');
          section.classList.add('sh-pr-write-target');
          section.classList.add('sh-pr-write-host');
          return section;
        }

        findPolarisWriteControl(root) {
          if (!root) return null;
          const candidates = Array.from(
            root.querySelectorAll('[role="button"], button, .R-Button--primary, a')
          );

          return (
            candidates.find((node) => {
              const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
              return (
                text.includes('bewertung schreiben') ||
                text.includes('write a review') ||
                text.includes('be the first to write a review') ||
                text === 'schreiben'
              );
            }) ||
            root.querySelector('.R-Button.R-Button--primary[role="button"]') ||
            null
          );
        }

        getPolarisEventBus(root) {
          if (!root) return null;
          const nodes = [root, ...root.querySelectorAll('*')];
          for (const el of nodes) {
            const inst = el.__vueParentComponent || el.__vue__;
            if (!inst) continue;
            const bus = inst.ctx?.eventBus || inst.proxy?.eventBus || inst.eventBus;
            if (bus && typeof bus.$emit === 'function') return bus;
          }
          return null;
        }

        triggerPolarisWriteForm(root) {
          if (!root) return false;

          const writeControl = this.findPolarisWriteControl(root);
          if (writeControl) {
            writeControl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            return true;
          }

          const bus = this.getPolarisEventBus(root);
          if (bus) {
            bus.$emit('writeReviewClicked', true);
            return true;
          }

          const walk = root.querySelectorAll('*');
          for (const el of walk) {
            const inst = el.__vueParentComponent || el.__vue__;
            if (inst?.proxy && 'showingReviewForm' in inst.proxy) {
              inst.proxy.showingReviewForm = true;
              return true;
            }
          }

          return false;
        }

        findWriteFormRoot(root) {
          const rating = document.querySelector('.R-RatingSelection');
          if (!rating) return null;

          const widgetRoot = root || this.getReviewsWidgetRoot();
          let current = rating;
          let best = rating;

          while (current && current !== widgetRoot && current !== document.body) {
            const text = (current.textContent || '').toLowerCase();
            const hasSubmit = text.includes('abschicken') || text.includes('submit');
            const hasCancel = text.includes('abbrechen') || text.includes('cancel');
            if (hasSubmit && hasCancel) best = current;

            if (
              current.matches('form, [class*="Form"], [class*="form"], [class*="Write"]') &&
              hasSubmit
            ) {
              best = current;
            }

            current = current.parentElement;
          }

          return (
            rating.closest('form') ||
            rating.closest('[class*="Form"]') ||
            rating.closest('[class*="Write"]') ||
            best
          );
        }

        resetModalBody(showLoader = true) {
          if (!this.modalBody) return;
          this.modalBody.innerHTML = showLoader ? '<div class="sh-pr__spinner" aria-hidden="true"></div>' : '';
          this.modalBody.classList.toggle('is-loading', showLoader);
        }

        openWriteModalShell() {
          if (!this.modal) return;
          this.modalOpen = true;
          this.modal.hidden = false;
          document.documentElement.classList.add('sh-pr-modal-open');
          this.resetModalBody(true);
          document.addEventListener('keydown', this._onModalKeydown);
          document.addEventListener('click', this._onModalClick, true);
        }

        onModalKeydown(event) {
          if (event.key === 'Escape') this.closeWriteModal();
        }

        onModalClick(event) {
          if (!this.modalOpen || !this.modalBody) return;
          const target = event.target;
          if (!(target instanceof Element) || !this.modalBody.contains(target)) return;

          const control = target.closest('[role="button"], button, a, input[type="submit"]');
          if (!control) return;

          const text = (control.textContent || control.getAttribute('value') || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

          if (text.includes('abbrechen') || text.includes('cancel')) {
            window.setTimeout(() => this.closeWriteModal(), 30);
          }
        }

        mountWriteFormIntoModal(formRoot) {
          if (!formRoot || !this.modalBody) return false;
          if (this.modalBody.contains(formRoot)) return true;

          this.modalBody.classList.remove('is-loading');
          this.modalBody.innerHTML = '';
          this.modalBody.appendChild(formRoot);

          const focusEl =
            this.modalBody.querySelector('.R-RatingSelection') ||
            this.modalBody.querySelector('textarea, input, [tabindex]');
          if (focusEl && typeof focusEl.focus === 'function') {
            try {
              focusEl.focus({ preventScroll: true });
            } catch (e) {
              focusEl.focus();
            }
          }

          return true;
        }

        watchForWriteForm(root) {
          if (this.formObserver) this.formObserver.disconnect();
          if (this.formPollTimer) window.clearInterval(this.formPollTimer);

          const tryMount = () => {
            const formRoot = this.findWriteFormRoot(root);
            if (!formRoot) return false;
            this.mountWriteFormIntoModal(formRoot);
            if (this.formObserver) this.formObserver.disconnect();
            if (this.formPollTimer) {
              window.clearInterval(this.formPollTimer);
              this.formPollTimer = null;
            }
            return true;
          };

          if (tryMount()) return;

          const observeTarget = root || document.body;
          this.formObserver = new MutationObserver(() => {
            tryMount();
          });
          this.formObserver.observe(observeTarget, { childList: true, subtree: true });

          let ticks = 0;
          this.formPollTimer = window.setInterval(() => {
            ticks += 1;
            if (tryMount() || ticks > 40) {
              window.clearInterval(this.formPollTimer);
              this.formPollTimer = null;
              if (ticks > 40 && this.modalBody?.classList.contains('is-loading')) {
                this.modalBody.classList.remove('is-loading');
                this.modalBody.innerHTML =
                  '<p style="margin:0;color:#666;font-size:1.4rem;">Das Formular konnte nicht geladen werden. Bitte versuche es erneut.</p>';
              }
            }
          }, 150);
        }

        teardownWriteModal(force = false) {
          if (this.formObserver) {
            this.formObserver.disconnect();
            this.formObserver = null;
          }
          if (this.formPollTimer) {
            window.clearInterval(this.formPollTimer);
            this.formPollTimer = null;
          }

          document.removeEventListener('keydown', this._onModalKeydown);
          document.removeEventListener('click', this._onModalClick, true);
          document.documentElement.classList.remove('sh-pr-modal-open');

          if (this.modal) this.modal.hidden = true;
          this.modalOpen = false;
          if (force) this.resetModalBody(false);
        }

        closeWriteModal() {
          const root = this.getReviewsWidgetRoot();
          const bus = this.getPolarisEventBus(root);
          if (bus) bus.$emit('closeWriteReview', { focus: false });

          const writeControl = this.findPolarisWriteControl(root);
          // Ensure Vue tears down form if cancel wasn't used
          if (!bus && writeControl) {
            /* no-op */
          }

          this.teardownWriteModal(true);
          this.resetModalBody(false);

          document.querySelectorAll('.sh-pr-write-host').forEach((el) => {
            el.classList.remove('sh-pr-write-host');
          });
        }

        openWriteReview() {
          this.openWriteModalShell();

          const attemptOpen = (attempts = 0) => {
            const root = this.getReviewsWidgetRoot();
            this.revealReviewsWidget(root);
            const opened = this.triggerPolarisWriteForm(root);

            if (opened) {
              this.watchForWriteForm(root);
              return;
            }

            if (attempts < 25) {
              window.setTimeout(() => attemptOpen(attempts + 1), 150);
              return;
            }

            this.teardownWriteModal(true);
            if (this.writeUrl) {
              window.open(this.writeUrl, '_blank', 'noopener');
            }
          };

          attemptOpen();
        }

        apiUrl(page, perPage) {
          const params = new URLSearchParams({
            type: 'product_review',
            store: this.store,
            sort: this.sort,
            page: String(page),
            per_page: String(perPage),
            widget: 'polaris',
            sku: this.sku,
            lang: this.lang,
            enable_avatars: 'true',
            include_subrating_breakdown: '1',
          });

          if (this.ratingFilter) params.set('rating', String(this.ratingFilter));

          return `https://api.reviews.io/timeline/data?${params.toString()}`;
        }

        async fetchReviews({ reset = true, page = 1 } = {}) {
          if (!this.store || !this.sku) {
            this.hideSection();
            return;
          }

          if (this.abortController) this.abortController.abort();
          this.abortController = new AbortController();
          this.setLoading(true);

          const perPage = this.mode === 'expanded' ? this.expandedCount : this.compactCount;

          try {
            const response = await fetch(this.apiUrl(page, perPage), {
              signal: this.abortController.signal,
              headers: { Accept: 'application/json' },
            });

            if (!response.ok) throw new Error(`Reviews.io ${response.status}`);

            const data = await response.json();
            const reviewCount = Number(data?.stats?.review_count || 0);
            const resultsCount = Number(data?.stats?.results_count || reviewCount);
            this.reviewCount = reviewCount;
            this.resultsCount = resultsCount;

            if (reviewCount <= 0) {
              this.hideSection();
              return;
            }

            this.revealSection();

            // Keep summary + star breakdown from the unfiltered baseline so
            // sort/rating choices never rewrite the Aufschlüsselung counts.
            if (!this.ratingFilter) {
              this.renderSummary(data);
            } else {
              this.renderRatingFilters();
            }

            const nextReviews = (data.timeline || [])
              .map((item) => item?._source || item)
              .filter(Boolean);

            this.page = page;
            this.reviews = reset ? nextReviews : this.reviews.concat(nextReviews);
            this.renderCards();
            this.updateFooter();
            this.updateFilterUi();

            if (this.emptyEl) {
              this.emptyEl.hidden = this.reviews.length > 0;
              this.emptyEl.textContent =
                this.reviews.length > 0
                  ? ''
                  : this.ratingFilter
                    ? 'Keine Bewertungen für diesen Filter gefunden.'
                    : 'Für dieses Produkt wurden noch keine Bewertungen abgegeben';
            }
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            this.hideSection();
          } finally {
            this.setLoading(false);
          }
        }

        renderSummary(data) {
          const average = Number(data?.stats?.average_rating || 0);
          const count = Number(data?.stats?.review_count || 0);
          const buckets = data?.aggregations?.ratings?.buckets || [];
          const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

          buckets.forEach((bucket) => {
            const key = Number(bucket.key);
            if (counts[key] !== undefined) counts[key] = Number(bucket.doc_count || 0);
          });

          this.ratingCounts = counts;
          this.renderRatingFilters();

          if (this.scoreEl) this.scoreEl.textContent = average.toFixed(2);
          if (this.summaryStarsEl) this.summaryStarsEl.innerHTML = this.starsMarkup(average);
          if (this.countEl) {
            this.countEl.textContent = `${count} Bewertung${count === 1 ? '' : 'en'}`;
          }

          if (this.barsEl) {
            let html = '';
            for (let rating = 5; rating >= 1; rating -= 1) {
              const value = counts[rating] || 0;
              const percent = count > 0 ? Math.round((value / count) * 100) : 0;
              html += `
                <div class="sh-pr__bar-row">
                  <span>${rating}</span>
                  <div class="sh-pr__bar-track"><span class="sh-pr__bar-fill" style="width:${percent}%"></span></div>
                  <span class="sh-pr__bar-value">${value}</span>
                </div>
              `;
            }
            this.barsEl.innerHTML = html;
          }
        }

        renderCards() {
          if (!this.grid) return;

          if (!this.reviews.length) {
            this.grid.innerHTML = '';
            return;
          }

          this.grid.innerHTML = this.reviews
            .map((review) => {
              const author = review.author || 'Anonym';
              const rating = Number(review.rating || 0);
              const comment = review.comments || review.review_title || '';
              const verified = Boolean(review.order_id || review.verified_by_shop);
              return `
                <article class="sh-pr__card">
                  <div class="sh-pr__card-top">
                    <span class="sh-pr__avatar">${this.escapeHtml(this.initials(author))}</span>
                    <div>
                      <p class="sh-pr__author">
                        <span>${this.escapeHtml(author)}</span>
                        ${
                          verified
                            ? `<span class="sh-pr__verified" title="Verifizierter Käufer" aria-label="Verifizierter Käufer"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.5 8.2L6.8 10.5L11.5 5.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`
                            : ''
                        }
                      </p>
                      <div class="sh-pr__stars sh-pr__card-stars" aria-label="${rating} von 5 Sternen">${this.starsMarkup(rating)}</div>
                    </div>
                  </div>
                  <p class="sh-pr__comment">${this.escapeHtml(comment)}</p>
                </article>
              `;
            })
            .join('');
        }

        updateFooter() {
          const visibleCount =
            typeof this.resultsCount === 'number' ? this.resultsCount : this.reviewCount;
          const hasReviews = this.reviews.length > 0;
          const hasMoreThanCompact = visibleCount > this.compactCount;
          const showingAll = this.reviews.length >= visibleCount;
          const canLoadMore = this.mode === 'expanded' && hasReviews && !showingAll;

          if (this.expandBtn) {
            this.expandBtn.hidden = !(
              this.mode === 'compact' &&
              hasReviews &&
              hasMoreThanCompact
            );
            this.expandBtn.textContent = `Alle ${visibleCount} Bewertungen lesen`;
          }

          if (this.moreBtn) this.moreBtn.hidden = !canLoadMore;
          if (this.backBtn) this.backBtn.hidden = this.mode !== 'expanded' || !hasReviews;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
